import React from 'react'
import {useForm} from 'react-hook-form'
import {Form, Button} from 'react-bootstrap';
import {Link} from "react-router-dom";
import {PulseLoader} from "react-spinners";

export default function ForgotPasswordForm(props) {

    const {register, handleSubmit, errors, formState} = useForm({
        mode: "onChange"
    })

    const {onSubmit, loading, errors: serverErrors} = props;

    return (
        <div className="forgot-password">
            <h1 className="text-center">Forgot Password</h1>
            <p>Please enter you registered email, We will send you the link to reset your password</p>

            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3">
                    <div className="error">
                        <p>
                            {errors.email && errors.email.type === "required" && "Email is required"}
                            {errors.email && errors.email.type === "pattern" && "Email is not valid"}
                        </p>
                    </div>
                    <Form.Control type="email" name="email" placeholder="Your Email" className="input input-flat input-xl" ref={register({required: true, pattern: /^\S+@\S+$/i})}/>
                </Form.Group>

                <Button variant="primary" type="submit" size="xl" disabled={formState.isValid == true ? "" : "disabled"} block>
                    <div className="d-flex justify-content-center align-content-center align-items-center">
                        <span className="mr-2"> Send Reset Link</span>
                        <PulseLoader size={10} color={"white"} loading={loading}/>
                    </div>
                </Button>

                <div className="sign-in-section mb-0 text-center">
                    <Link to="/signin">Back To Sign In</Link>
                </div>
            </Form>
        </div>
    );
}
